/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Field_Trade_NameInputs */

const en_clients_field_trade_name = /** @type {(inputs: Clients_Field_Trade_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trade name`)
};

const pt_br2_clients_field_trade_name = /** @type {(inputs: Clients_Field_Trade_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome fantasia`)
};

/**
* | output |
* | --- |
* | "Trade name" |
*
* @param {Clients_Field_Trade_NameInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_field_trade_name = /** @type {((inputs?: Clients_Field_Trade_NameInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Field_Trade_NameInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_field_trade_name(inputs)
	return pt_br2_clients_field_trade_name(inputs)
});